
// PF e PJ são o mesmo esqueleto (P24): o que muda entre as duas árvores mora aqui, num lugar só.
// Leve de propósito: entra no manifesto e na rota (JS inicial).

export type PersonKind = 'natural' | 'legal';
export type PersonResource = 'NaturalPerson' | 'LegalPerson';

export interface PersonKindConfig {
  readonly kind: PersonKind;
  readonly resource: PersonResource;
  /** Raiz do legado (`router.tsx:829`, `:910`). */
  readonly base: '/pessoas-fisicas' | '/pessoas-juridicas';
  /** Id do cadastro novo: PF `nova`, PJ `novo` (`NaturalPersonFormContainer.tsx:58`, `LegalPersonFormContainer.tsx:50`). */
  readonly newId: 'nova' | 'novo';
  /** Flag que liga o grupo do menu (`router.tsx:827`, `:908`). */
  readonly menuFlag: 'NATURAL_PERSON_MENU' | 'LEGAL_PERSON_MENU';
  /** Grupo da navegação da casca (`navigation.ts`). */
  readonly section: 'natural-person' | 'legal-person';
}

export const PERSON_KINDS: Readonly<Record<PersonKind, PersonKindConfig>> = {
  natural: {
    kind: 'natural',
    resource: 'NaturalPerson',
    base: '/pessoas-fisicas',
    newId: 'nova',
    menuFlag: 'NATURAL_PERSON_MENU',
    section: 'natural-person',
  },
  legal: {
    kind: 'legal',
    resource: 'LegalPerson',
    base: '/pessoas-juridicas',
    newId: 'novo',
    menuFlag: 'LEGAL_PERSON_MENU',
    section: 'legal-person',
  },
};

export const personListPath = (kind: PersonKind) => `${PERSON_KINDS[kind].base}/todas` as const;
export const personPendingPath = (kind: PersonKind) => `${PERSON_KINDS[kind].base}/pendentes` as const;
export const personRecordPath = (kind: PersonKind, id: string) => `${personListPath(kind)}/${encodeURIComponent(id)}`;
export const personKindOf = (resource: string): PersonKind => (resource === 'LegalPerson' ? 'legal' : 'natural');
